import PopoverDropdownMenu from "../../../Menus/PopoverDropdownMenu";
import DropdownOptionWithIcon from "../../../Menus/DropdownOptionWithIcon";
import useUninstallCloudApp from "../../../../api/api-hooks/cloudApps/useUninstallCloudApp";
import useWorkspacePermissions from "../../../../hooks/useWorkspacePermissions";

export default function CloudAppViewerOptions({ id }: { id: string }) {
  const { uninstallCloudApp } = useUninstallCloudApp();
  const { wPermissions } = useWorkspacePermissions();

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Uninstall App"
        icon="mdi mdi-delete-outline"
        disabled={!wPermissions.workspace_uninstall_cloud_app}
        onClick={() => uninstallCloudApp(id)}
      />
    </PopoverDropdownMenu>
  );
}
